import React from 'react'
import ProductsCard from "./ProductsCard";
import ProductsCardData from "./ProductsCardData"

const Products = () => {
  return (
<div id="#products" className="product">
    <div className="container-fluid py-5">
        <div className="container">
            <div className="row">
                <div className="contain">
                   <div className="hold">
                     <div><h2>New Arrival</h2></div>
                     <div><button className="button view">View More<i className="fa-solid fa-arrow-right mx-3"></i></button></div>
                   </div>
                </div>
           {ProductsCardData.map((ide, num) =>{
               return (
                   <ProductsCard
                   key={num}
                   imgsrc={ide.imgsrc}
                   title={ide.title}
                   />
               )
           })}
        </div>
      </div>
   </div>
 </div>
  )
}

export default Products;